module.exports = __webpack_public_path__ + "img/744.88f735f5.jpg";